var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0089 24.9999C15.7528 25.0008 15.4997 24.9419 15.2682 24.8276C15.0368 24.7133 14.8329 24.5464 14.6715 24.3392L6.39005 13.626C6.13786 13.3065 6 12.9057 6 12.4921C6 12.0786 6.13786 11.6778 6.39005 11.3583L14.963 0.645033C15.2541 0.280394 15.6723 0.0510867 16.1256 0.00755554C16.579 -0.0359756 17.0305 0.109836 17.3806 0.412911C17.7307 0.715987 17.9509 1.1515 17.9927 1.62365C18.0345 2.09579 17.8945 2.56589 17.6035 2.93053L9.93926 12.5011L17.3463 22.0716C17.556 22.3337 17.6892 22.6528 17.7301 22.9913C17.771 23.3297 17.718 23.6733 17.5773 23.9814C17.4366 24.2894 17.2142 24.5491 16.9362 24.7296C16.6583 24.9101 16.3365 25.0039 16.0089 24.9999Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3a7f102e.svg";
export { ForwardRef as ReactComponent };